import { styled } from '@mui/material/styles';
import { Box, Skeleton } from '@mui/material';

export const ImageContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'inline-block',
  overflow: 'hidden'
}));

export const AuthImage = styled('img')(() => ({
  display: 'block',
  maxWidth: '100%',
  height: 'auto'
}));

export const LoaderContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  zIndex: 1
}));

export const ErrorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[600],
  fontSize: '0.875rem',
  fontWeight: 500,
  textAlign: 'center',
  padding: theme.spacing(2)
}));

export const ImageSkeleton = styled(Skeleton)(() => ({
  borderRadius: 'inherit'
}));
